require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")

require('src/admin/js/application')
